import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgFacebookSolid = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-.5 -.5 16 16"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Facebook F Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path d="M5.2074 8.7432V14.85H8.538V8.7432h2.4835l.5168-2.808H8.5379V4.942c0-1.4844.5828-2.0529 2.0873-2.0529.468 0 .844.0115 1.0623.0345V.3768C11.2769.2648 10.272.15 9.692.15c-3.0692 0-4.4847 1.4499-4.4847 4.5765v1.2088H3.3125v2.8079z" />
  </svg>
);
export default SvgFacebookSolid;
